/**
 * Do not edit directly.
 * Generated via Design Token Pipeline
 */
import React from 'react';
import { convertIconPropsToSvgProps } from '../../utils';
export const IconProjectsEmpty = React.forwardRef((iconProps, ref) => {
    const props = convertIconPropsToSvgProps({
        ...iconProps,
        'aria-label': 'icon-projects-empty',
    });
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ref: ref, ...props },
        React.createElement("g", null,
            React.createElement("path", { d: "M19.53 4.208a1.305 1.305 0 0 0-.422.005L4.942 5.953a2.322 2.322 0 0 0-1.854 1.552l-2.022 6.499a1.39 1.39 0 0 0 .83 1.78c.222.09.483.104.711.052l2.014-.247.208 1.694c.115.939.998 1.62 1.947 1.504l6.088-.747 1.454 1.703c.377.395.895.588 1.43.545l5.254-.645c.949-.117 1.64-.992 1.525-1.93L21.051 5.694c-.095-.778-.735-1.397-1.521-1.486ZM2.903 14.034l1.864-6.061a.65.65 0 0 1 .383-.326L18.876 5.96l-1.91 6.067a.65.65 0 0 1-.383.326l-13.68 1.68Zm12.68 4.531-1.377-1.643a1.758 1.758 0 0 0-1.553-.6l-6.065.745-.21-1.717 10.416-1.279a2.322 2.322 0 0 0 1.853-1.552l1.06-3.43 1.084 8.837-5.208.64Z" })),
        React.createElement("defs", null,
            React.createElement("clipPath", null,
                React.createElement("path", { d: "M0 0h24v24H0z" })))));
});
IconProjectsEmpty.displayName = 'IconProjectsEmpty';
export default IconProjectsEmpty;
